import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { Emitter } from '@/utils';
import { ApiEventNames } from '@/constants/common';
import { modal } from '@/share/components';
export const useApiEventHandler = (autoHandler = false) => {
  const apiEventBus = new Emitter({}, 'api-event-bus');
  let offHandlers = null;
  const handleApiEvents = () => {
    const offHandlers = new Set();
    offHandlers.add(apiEventBus.on(ApiEventNames.ApiError, params => {
      const {
        error,
        showError
      } = params || {};
      if (showError) {
        modal.message.error(error);
      } else {
        console.error(`fetch api error: ${error}`);
      }
    }));
    offHandlers.add(apiEventBus.on(ApiEventNames.ApiNotFound, params => {
      const {
        error,
        params: {
          name
        } = {}
      } = params || {};
      console.debug(error, `api[${name}] not found.`);
    }));
    offHandlers.add(apiEventBus.on(ApiEventNames.LocalApiError, params => {
      const {
        error
      } = params || {};
      console.error(error);
    }));
    return () => {
      Array.from(offHandlers).forEach(h => h());
    };
  };
  onMounted(() => {
    if (autoHandler) {
      offHandlers = handleApiEvents();
    }
  });
  onUnmounted(() => {
    if (offHandlers) {
      offHandlers();
      offHandlers = null;
    }
  });
  return {
    handleApiEvents
  };
};